// v2/components/AccountCard.js — bakiye karti
import React, { useState, useEffect, useRef } from 'react';
import { ArrowRight } from 'lucide-react';
import { formatTRY } from '../utils/format';
import styles from './StatCards.module.css';

/** Acilista sayarak gelen deger (600ms, ease-out) */
function useCountUp(target, duration = 600) {
  const [value, setValue] = useState(target);
  const raf = useRef(null);

  useEffect(() => {
    const reduce = typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !Number.isFinite(target)) { setValue(target); return undefined; }

    const t0 = (typeof performance !== 'undefined' ? performance.now() : Date.now());
    const tick = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      setValue(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => { if (raf.current) cancelAnimationFrame(raf.current); };
  }, [target, duration]);

  return value;
}

export default function AccountCard({ data, onOpenAccount = () => {} }) {
  const shown = useCountUp(data.balance);

  return (
    <section className={styles.balCard} aria-label="Bakiyem">
      <span className={styles.balWatermark}>₺</span>

      <div className={styles.balHead}>
        <div>
          <h2 className={styles.balTitle}>Bakiyem</h2>
          <span className={styles.balSub}>Güncel Bakiye</span>
          <div className={styles.balAmount}>{formatTRY(shown)}</div>
        </div>
        <button type="button" className={styles.balBtn} onClick={onOpenAccount}>
          Hesabım <ArrowRight size={13} />
        </button>
      </div>

      <div className={styles.balFoot}>
        <span className={styles.balFootLabel}>Son Hareket</span>
        <span className={styles.balDate}>{data.lastActivity}</span>
      </div>
    </section>
  );
}
